module.exports = __webpack_public_path__ + "img/landing-general-info-screen-2.28ddb872.png";